/*
 * md-pdp-blocos.js
 * ------------------------------------------------------------
 * Atualiza no load dos 3 blocos reutilizaveis da PDP:
 *   1. Data de hoje no card UPDATE ("October 18")
 *      + aviso "Expected sell out" (TODAY / in 1 day / in N days)
 *   2. Barra de estoque: calcula largura em %
 *   3. Entrega: janela "Xh Ymin" ate o corte e intervalo
 *      "Mon dd to Mon dd" calculado em dias uteis
 *
 * Prefix md-* para nao vazar. Reaplica em shopify:section:load
 * pra sobreviver ao re-render de section do editor e trocas de variante.
 */
(function () {
  'use strict';

  var MESES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  var MESES_CURTOS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  function somarDiasUteis(data, dias) {
    var d = new Date(data.getTime());
    var restantes = dias;
    while (restantes > 0) {
      d.setDate(d.getDate() + 1);
      var dia = d.getDay();
      if (dia !== 0 && dia !== 6) {
        restantes--;
      }
    }
    return d;
  }

  function formataData(data) {
    return MESES_CURTOS[data.getMonth()] + ' ' + data.getDate();
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function atualizarUpdate(root) {
    var hoje = new Date();
    var labelData = root.querySelector('[data-md-upd-data]');
    if (labelData) {
      labelData.textContent = MESES[hoje.getMonth()] + ' ' + hoje.getDate();
    }
    var selloutEl = root.querySelector('[data-md-upd-sellout]');
    if (!selloutEl) return;
    var selloutDias = parseInt(root.getAttribute('data-md-sellout-days'), 10);
    if (isNaN(selloutDias) || selloutDias <= 0) {
      selloutEl.textContent = 'TODAY';
    } else if (selloutDias === 1) {
      selloutEl.textContent = 'in 1 day';
    } else {
      selloutEl.textContent = 'in ' + selloutDias + ' days';
    }
  }

  function atualizarEstoque(root) {
    var valor = parseInt(root.getAttribute('data-md-estoque-valor'), 10);
    var max = parseInt(root.getAttribute('data-md-estoque-max'), 10);
    if (isNaN(valor) || valor < 0) valor = 0;
    if (isNaN(max) || max <= 0) max = 50;
    var pct = Math.min(100, Math.max(4, Math.round((valor / max) * 100)));
    var fill = root.querySelector('[data-md-estoque-fill]');
    if (fill) {
      window.requestAnimationFrame(function () {
        fill.style.width = pct + '%';
      });
    }
    var label = root.querySelector('[data-md-estoque-label]');
    if (label) {
      label.hidden = false;
    }
  }

  function atualizarEntrega(root) {
    var corte = parseInt(root.getAttribute('data-md-corte'), 10);
    var prazoMin = parseInt(root.getAttribute('data-md-prazo-min'), 10);
    var prazoMax = parseInt(root.getAttribute('data-md-prazo-max'), 10);
    if (isNaN(corte) || corte < 0 || corte > 23) corte = 15;
    if (isNaN(prazoMin) || prazoMin <= 0) prazoMin = 6;
    if (isNaN(prazoMax) || prazoMax < prazoMin) prazoMax = prazoMin + 9;

    var agora = new Date();
    var limite = new Date(
      agora.getFullYear(),
      agora.getMonth(),
      agora.getDate(),
      corte, 0, 0, 0
    );
    if (limite.getTime() <= agora.getTime()) {
      limite.setDate(limite.getDate() + 1);
    }
    var diffMs = Math.max(0, limite.getTime() - agora.getTime());
    var totalMin = Math.floor(diffMs / 60000);
    var horas = Math.floor(totalMin / 60);
    var minutos = totalMin % 60;
    var janelaStr = horas + 'h ' + pad2(minutos) + 'min';

    var dataInicio = somarDiasUteis(agora, prazoMin);
    var dataFim = somarDiasUteis(agora, prazoMax);

    var janelaEl = root.querySelector('[data-md-entrega-janela]');
    if (janelaEl) janelaEl.textContent = janelaStr;
    var dataEl = root.querySelector('[data-md-entrega-data]');
    if (dataEl) dataEl.textContent = formataData(dataInicio) + ' to ' + formataData(dataFim);
  }

  function iniciar() {
    var updates = document.querySelectorAll('[data-md-upd]');
    for (var i = 0; i < updates.length; i++) atualizarUpdate(updates[i]);

    var estoques = document.querySelectorAll('[data-md-estoque]');
    for (var j = 0; j < estoques.length; j++) atualizarEstoque(estoques[j]);

    var entregas = document.querySelectorAll('[data-md-entrega]');
    for (var k = 0; k < entregas.length; k++) atualizarEntrega(entregas[k]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();
